export default {
  atterbergLimit: {
    ASTM_D_4318: { methodA_Rev2017: '110440', methodB_Rev2017: '110441' },
  },
  maximumDryDensity: {
    ASTM_D_698: { rev2012e2: '110416', rev2012e2_metric: '110418' },
    ASTM_D_1557: { rev2012: '110415', rev2012_metric: '110417' },
  },
  oversizeDetermination: { ASTM_C_136_D_6913: '110419' },
  moistureContent: {
    ASTM_D_2216: { rev2019: '110099' },

    //The oven drying part of an organic content test
    ASTM_D2974: { rev2020: '110619' },
  },
  organicContent: { ASTM_D2974: { rev2020: '110618' } },
  psdSieveAnalysis: {
    ASTM_D6913: { rev2017: '110430' },
    ASTM_C136: { rev2019: '110431' },
  },
  soilClassification: {
    ASTM_D2487: { rev2017: '110460' },
    ASTM: { estimated_Psd: '110461', estimated_Al: '110462' },
  },
  specificGravityCoarse: {
    ASTM_C_127: { rev2015: '110421' },
  },
  wash: {
    ASTM_C117: { rev2017: '110450' },
    ASTM_D6913: { rev2017: '110452' },
    ASTM_D1140: { rev2017: '110453' },
  },
};
